import script from "./TheSideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSideMenu.vue?vue&type=script&setup=true&lang=js"

import "./TheSideMenu.vue?vue&type=style&index=0&id=228d6fa0&lang=css"

const __exports__ = script;

export default __exports__